// Plans Reducer

import { API_STATUS, SORTING_CRITERIA } from '../../../utilities/constants';
import { initializeState } from '../../../utilities/storageUtils';
import plansActionTypes from './plans.types';

const INITIAL_STATE = {
  availabilityList: [],
  qualifyingID: undefined,
  requiresQualifyingID: false,
  isIdMeValidationRequired: false,
  isIdMeValidationRequiredWithError: false,
  qualifyingIDError: false,
  offerCodeError: undefined,
  promoDescription: '',
  planAvailabilityApiStatus: API_STATUS.IDLE,
  availabilityErrorMessage: '',
  selectedSuiteForRange: '',
  selectedSuiteRange: {},
  selectedSuiteRangeRestrictions: {},
  recentSearchesList: [],
  recentSearchesApiStatus: API_STATUS.IDLE,
  deleteRecentSearchesApiStatus: API_STATUS.IDLE,
  selectedSuiteForCalendar: '',
  availabilityHighestRatesList: [],
  availabilityHighestRatesRequestFailed: false,
  availabilityHighestRatesRequestDatesExceededFailed: false,
  filtersApplied: {
    amenities: [],
    accessibility: false,
    themed: false,
    standard: false,
    premium: false,
    condo: false
  },
  sorting: SORTING_CRITERIA.recommendedForYou,
  sortSuite: '',
  oldFiltersApplied: {},
  availabilityRangeBySuiteApiStatus: API_STATUS.IDLE,
  emailCampaign: {
    isEmailCampaign: false,
    planCalendarShouldBeBlocked: false,
    campaignObject: {}
  },
  isBookingWidgetFocused: false,
  isErrorModalAlreadyClosed: false,
  offerType: '',
  personalizationResponses: [],
  dealsSummary: {},
  lowestRateCalendarList: {},
  lowestRatesByStayList: {},
  lastCalendarRatesDateSelection: { start: '', end: '' },
  upsellPackagesContent: [],
  latestVersionJEventErrorObj: null,
  latestVersionHEventErrorObj: null,
  isCartOpenClose: false,
  cartReturnedPageLinkClicked: '',
  errors: [],
  upsellRecommendationData: null,
  savePointsForLater: true,
  isChangedToFlex: false,
  isProperty: false,
  isPropertyRestricted: false
};

const plansReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Get Book information reducers
  switch (action.type) {
    case plansActionTypes.SET_PLANS_AVAILABILITY_DETAILS_ERROR:
      return {
        ...state,
        offerCodeError: action.error,
        planAvailabilityApiStatus: API_STATUS.ERROR,
        availabilityErrorMessage: ''
      };
    case plansActionTypes.SET_PLANS_IS_CART_OPEN_CLOSE:
      return {
        ...state,
        isCartOpenClose: action.value
      };
    case plansActionTypes.SET_PLANS_IS_CART_OPEN_CLOSE_CLEAN:
      return {
        ...state,
        isCartOpenClose: false
      };

    case plansActionTypes.SET_PLANS_CHANGED_TO_FLEXIBLE:
      return {
        ...state,
        isChangedToFlex: action.isChangedToFlex
      };
    case plansActionTypes.SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED:
      return {
        ...state,
        cartReturnedPageLinkClicked: action.pageToReturn
      };
    case plansActionTypes.SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED_CLEAN:
      return {
        ...state,
        cartReturnedPageLinkClicked: ''
      };
    // Availability item request succeeded
    case plansActionTypes.GET_PLANS_AVAILABILITY_INFO_SUCCESS:
      return {
        ...state,
        availabilityList: action.availabilityList,
        planAvailabilityApiStatus: API_STATUS.SUCCEEDED,
        availabilityErrorMessage: '',
        requiresQualifyingID: action.requiresQualifyingID,
        isIdMeValidationRequired: action.isIdMeValidationRequired,
        isIdMeValidationRequiredWithError: false,
        offerCodeError: action.offerCodeError,
        isErrorModalAlreadyClosed: false,
        promoDescription: action.promoDescription,
        offerType: action.offerType,
        personalizationRules: action.personalizationRules,
        personalizationResponses: action.personalizationResponses,
        upsellPackagesContent: action.upsellPackagesContent,
        isProperty: action.isProperty,
        isPropertyRestricted: action.isPropertyRestricted,
        errors: action.errors
      };
    // The request is currently running
    case plansActionTypes.GET_PLANS_AVAILABILITY_INFO_LOADING:
      return {
        ...state,
        planAvailabilityApiStatus: API_STATUS.LOADING,
        availabilityList: [],
        offerCodeError: undefined,
        isPropertyRestricted: false
      };
    // Availability item request failed
    case plansActionTypes.GET_PLANS_AVAILABILITY_INFO_ERROR:
      return {
        ...state,
        availabilityList: [],
        availabilityErrorMessage: action.availabilityErrorMessage,
        planAvailabilityApiStatus: API_STATUS.ERROR,
        requiresQualifyingID: false,
        isIdMeValidationRequired: action.isIdMeValidationRequired,
        isIdMeValidationRequiredWithError: true,
        promoDescription: '',
        offerCodeError: undefined,
        isPropertyRestricted: false
      };
    case plansActionTypes.SET_PLANS_IS_ERROR_MODAL_ALREADY_CLOSED:
      return {
        ...state,
        isErrorModalAlreadyClosed: action.value
      };
    // Recent Searches items request succeeded
    case plansActionTypes.GET_PLANS_RECENT_SEARCHES_INFO_SUCCESS:
      return {
        ...state,
        recentSearchesList: action.recentSearchesList,
        recentSearchesApiStatus: API_STATUS.SUCCEEDED
      };
    // The request is currently running
    case plansActionTypes.GET_PLANS_RECENT_SEARCHES_INFO_LOADING:
      return {
        ...state,
        recentSearchesApiStatus: API_STATUS.LOADING
      };
    // Recent Searches request failed
    case plansActionTypes.GET_PLANS_RECENT_SEARCHES_INFO_ERROR:
      return {
        ...state,
        recentSearchesApiStatus: API_STATUS.ERROR
      };
    // The delete request is currently running
    case plansActionTypes.DEL_PLANS_RECENT_SEARCHES_LOADING:
      return {
        ...state,
        deleteRecentSearchesApiStatus: API_STATUS.LOADING
      };
    // Delete recent searches succeeded
    case plansActionTypes.DEL_PLANS_RECENT_SEARCHES_SUCCESS:
      return {
        ...state,
        deleteRecentSearchesApiStatus: API_STATUS.SUCCEEDED
      };
    // Delete recent searches failed
    case plansActionTypes.DEL_PLANS_RECENT_SEARCHES_ERROR:
      return {
        ...state,
        deleteRecentSearchesApiStatus: API_STATUS.ERROR
      };

    case plansActionTypes.SELECT_PLANS_SUITE_FOR_RANGE_TYPE:
      return {
        ...state,
        selectedSuiteForRange: action.selectedSuiteForRange
      };

    case plansActionTypes.OPEN_PLANS_RATES_CALENDAR:
      return {
        ...state,
        selectedSuiteRange: { ...state.selectedSuiteRange, ...action.selectedSuiteRange },
        dealsSummary: action.dealsSummary
      };

    case plansActionTypes.CLOSE_PLANS_RATES_CALENDAR:
      return {
        ...state,
        selectedSuiteRange: INITIAL_STATE.selectedSuiteRange
      };

    case plansActionTypes.OPEN_PLANS_RATES_CALENDAR_RESTRICTION:
      return {
        ...state,
        selectedSuiteRangeRestrictions: action.selectedSuiteRangeRestrictions,
        dealsSummary: action.dealsSummary
      };

    case plansActionTypes.OPEN_PLANS_CALENDAR_RATES_BY_STAY:
      return {
        ...state,
        lowestRatesByStayList: action.lowestRatesByStayList
      };

    case plansActionTypes.LAST_PLANS_CALENDAR_RATES_BY_STAY_SELECTION:
      return {
        ...state,
        lastCalendarRatesDateSelection: action.lastCalendarRatesDateSelection
      };

    case plansActionTypes.CLEAN_PLANS_CALENDAR_RATES_BY_STAY:
      return {
        ...state,
        lowestRatesByStayList: {}
      };

    case plansActionTypes.OPEN_PLANS_RATES_CALENDAR_RESTRICTION_INCREMENT:
      return {
        ...state,
        selectedSuiteRangeRestrictions:
          Object.keys(action.selectedSuiteRangeRestrictions).length > 0
            ? { ...state.selectedSuiteRangeRestrictions, ...action.selectedSuiteRangeRestrictions }
            : { ...state.selectedSuiteRangeRestrictions },
        dealsSummary: action.dealsSummary
      };

    case plansActionTypes.GET_PLANS_LOWEST_RATES_CALENDAR:
      return {
        ...state,
        lowestRateCalendarList: action.lowestRateCalendarList
      };

    case plansActionTypes.GET_PLANS_LOWEST_RATES_CALENDAR_MOBILE:
      return {
        ...state,
        lowestRateCalendarList:
          Object.keys(action.lowestRateCalendarList).length > 0
            ? { ...state.lowestRateCalendarList, ...action.lowestRateCalendarList }
            : { ...state.lowestRateCalendarList }
      };

    case plansActionTypes.CLEAN_PLANS_CALENDAR_RESTRICTIONS_AND_LOWEST_RATES:
      return {
        ...state,
        lowestRateCalendarList: INITIAL_STATE.lowestRateCalendarList,
        selectedSuiteRangeRestrictions: INITIAL_STATE.selectedSuiteRangeRestrictions
      };

    case plansActionTypes.GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_LOADING:
      return {
        ...state,
        availabilityRangeBySuiteApiStatus: API_STATUS.LOADING
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_SUCCESS:
      return {
        ...state,
        availabilityRangeBySuiteApiStatus: API_STATUS.SUCCEEDED
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_ERROR:
      return {
        ...state,
        availabilityRangeBySuiteApiStatus: API_STATUS.ERROR
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_RESET:
      return {
        ...state,
        selectedSuiteRange: {},
        availabilityRangeBySuiteApiStatus: API_STATUS.IDLE
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_HIGHEST_RATES_SUCCESS:
      return {
        ...state,
        availabilityHighestRatesList: action.availabilityHighestRatesList,
        availabilityHighestRatesRequestFailed: false,
        availabilityHighestRatesRequestDatesExceededFailed: false
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_HIGHEST_RATES_ERROR:
      return {
        ...state,
        availabilityHighestRatesList: [],
        availabilityHighestRatesRequestFailed: true,
        availabilityHighestRatesRequestDatesExceededFailed: false
      };
    case plansActionTypes.GET_PLANS_AVAILABILITY_HIGHEST_RATES_DATES_EXCEEDED_ERROR:
      return {
        ...state,
        availabilityHighestRatesList: [],
        availabilityHighestRatesRequestFailed: false,
        availabilityHighestRatesRequestDatesExceededFailed: true
      };
    case plansActionTypes.SET_PLANS_APPLIED_FILTERS:
      return {
        ...state,
        filtersApplied: action.filtersApplied,
        oldFiltersApplied: state.filtersApplied
      };

    case plansActionTypes.SET_PLANS_SELECTED_SUITE_NAME_FOR_CALENDAR:
      return {
        ...state,
        selectedSuiteForCalendar: action.selectedSuiteForCalendar
      };
    case plansActionTypes.TOGGLE_PLANS_EMAIL_CAMPAIGNS:
      return {
        ...state,
        emailCampaign: action.emailCampaign
      };
    case plansActionTypes.SET_PLANS_QUALIFYING_ID:
      return {
        ...state,
        qualifyingID: action.code
      };
    case plansActionTypes.GET_PLANS_QUALIFYING_ID_HAS_ERROR:
      return {
        ...state,
        qualifyingIDError: true
      };
    case plansActionTypes.SET_PLANS_IS_BOOKING_WIDGET_FOCUSED:
      return {
        ...state,
        isBookingWidgetFocused: action.value
      };
    case plansActionTypes.SET_PLANS_SORTING_ORDER:
      return {
        ...state,
        sorting: action.sortingType
      };
    case plansActionTypes.SET_PLANS_SUITE_CODE_FILTER:
      return {
        ...state,
        sortSuite: action.suiteCode
      };
    case plansActionTypes.CLEAR_PLANS_ALL_AVAILABILITY_DATA:
      return INITIAL_STATE;
    case plansActionTypes.CLEAR_PLANS_ALL_HIGHEST_RATES_ERRORS:
      return {
        ...state,
        availabilityHighestRatesRequestFailed: false,
        availabilityHighestRatesRequestDatesExceededFailed: false
      };
    case plansActionTypes.SET_PLANS_UPSELL_RECOMMENDATION_DATA:
      return {
        ...state,
        upsellRecommendationData: action.upsellRecommendationData
      };
    case plansActionTypes.SET_PLANS_SAVE_POINTS_FOR_LATER:
      return {
        ...state,
        savePointsForLater: action.savePointsForLater
      };
    default:
      return state;
  }
};

export default plansReducer;
